import { useState, useCallback, useEffect } from 'react';

const useWakeLock = () => {
  const [wakeLockSentinel, setWakeLockSentinel] = useState(null);

  const acquireWakeLock = useCallback(async () => {
    if (wakeLockSentinel) return;
    if ('wakeLock' in navigator) {
      try {
        const sentinel = await navigator.wakeLock.request('screen');
        setWakeLockSentinel(sentinel);
        console.log('Wake Lock acquired');
        sentinel.addEventListener('release', () => {
          console.log('Wake Lock released by system');
          setWakeLockSentinel(null);
        });
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    } else {
      console.log('Screen Wake Lock API not supported');
    }
  }, [wakeLockSentinel]);

  const releaseWakeLock = useCallback(async () => {
    if (wakeLockSentinel) {
      try {
        await wakeLockSentinel.release();
        setWakeLockSentinel(null);
        console.log('Wake Lock released');
      } catch (err) {
        console.error(`${err.name}, ${err.message}`);
      }
    }
  }, [wakeLockSentinel]);

  useEffect(() => {
    acquireWakeLock();
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !wakeLockSentinel) {
        acquireWakeLock();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('fullscreenchange', acquireWakeLock); // Re-acquire on fullscreen change

    return () => {
      releaseWakeLock();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('fullscreenchange', acquireWakeLock);
    };
  }, [acquireWakeLock, releaseWakeLock, wakeLockSentinel]);
};

export default useWakeLock;
